import { EditIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Flex,
  SimpleGrid,
  Spinner,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../shared/hooks/useApi";
import { CaregiverId } from "../../../../shared/schema/schema";
import DetailRow from "./DetailRow";
import EditExtendedContactDetailsModal from "./EditExtendedContactDetailsModal";
import { FIELDS } from "./extended-contact-details.utils";

interface Props {
  caregiverId: CaregiverId;
}

export default function CaregiverExtendedContactDetails(props: Props) {
  const { queries } = useApi();
  const disclosure = useDisclosure();

  const query = useQuery(queries.caregiver.extendedContactDetails(props.caregiverId));

  return (
    <Box>
      <Flex align="center" justify="space-between" mb={4}>
        <Text fontSize="lg" fontWeight="semibold">
          Extended Contact Details
        </Text>
        {query.status === "success" && (
          <Button leftIcon={<EditIcon />} size="sm" variant="outline" onClick={disclosure.onOpen}>
            Edit
          </Button>
        )}
      </Flex>

      {(() => {
        switch (query.status) {
          case "pending":
            return (
              <Center py={8}>
                <Spinner size="sm" />
              </Center>
            );
          case "error":
            return <Text color="red.500">Failed to load extended contact details</Text>;
          case "success":
            return (
              <>
                {query.data === null && (
                  <Center bg="gray.50" color="gray.500" mb={4} py={4} rounded="md">
                    No extended contact details on record.
                  </Center>
                )}
                <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={12} spacingY={3}>
                  {FIELDS.map((field) => (
                    <DetailRow key={field.key} details={query.data} field={field} />
                  ))}
                </SimpleGrid>
                {disclosure.isOpen && (
                  <EditExtendedContactDetailsModal
                    caregiverId={props.caregiverId}
                    details={query.data}
                    isOpen={disclosure.isOpen}
                    onClose={disclosure.onClose}
                  />
                )}
              </>
            );
        }
      })()}
    </Box>
  );
}
